import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class LPOnTheMarket extends Vue {
    public title: string = 'LPOnTheMarket';

    @Prop({ default: null })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
        // if (T_T.simpleDetect(val)) {
        //     this.dataWatched = val;
        // }
    }

    @Watch('$store.state.lpCreatePage.onMarketProperty', { immediate: true, deep: true })
    public onOnMarketPropertyInput(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            this.dataWatched = val;
        }
    }

    public dataWatched: any = [];

    @Prop({ default: 4 })
    public page: any;

    @Prop({
        default: () => {
            return {
                comparitives: [],
                prediction: 0,
            };
        }
    })
    public cmaResult: any;
}
